(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-d2f-contact-ticker]').forEach((viewport) => {
      if (viewport.dataset.tickerReady) return;
      viewport.dataset.tickerReady = 'true';
      const track = viewport.querySelector('.d2f-topbar__track');
      const first = track.firstElementChild;
      const mobile = window.matchMedia('(max-width: 989px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      while (track.children.length < 9) {
        const copy = first.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      }
      track.querySelectorAll('[aria-hidden="true"] a').forEach((link) => link.tabIndex = -1);
      let width = 0;
      let position = 0;
      let written = 0;
      let touching = false;
      let userScrolling = false;
      let focused = false;
      let resumeAt = 0;
      let previous = 0;
      const write = () => {
        viewport.scrollLeft = position;
        written = viewport.scrollLeft;
      };
      const center = () => {
        if (!width || !mobile.matches) return;
        position = width * 4 + ((viewport.scrollLeft % width) + width) % width;
        write();
      };
      const measure = () => {
        const next = first.getBoundingClientRect().width;
        if (!mobile.matches || !next) return;
        const fraction = width ? ((viewport.scrollLeft % width) + width) % width / width : 0;
        width = next;
        position = width * (4 + fraction);
        write();
      };
      const begin = () => {
        if (!mobile.matches) return;
        center();
        touching = true;
        userScrolling = true;
      };
      viewport.addEventListener('touchstart', begin, { passive: true });
      viewport.addEventListener('pointerdown', (event) => { if (event.pointerType !== 'touch') begin(); }, { passive: true });
      const release = () => {
        touching = false;
        resumeAt = performance.now() + 700;
      };
      window.addEventListener('touchend', (event) => { if (!event.touches.length) release(); }, { passive: true });
      window.addEventListener('touchcancel', release, { passive: true });
      window.addEventListener('pointerup', (event) => { if (event.pointerType !== 'touch') release(); }, { passive: true });
      window.addEventListener('pointercancel', (event) => { if (event.pointerType !== 'touch') release(); }, { passive: true });
      viewport.addEventListener('scroll', () => {
        const current = viewport.scrollLeft;
        if (!mobile.matches || !width || Math.abs(current - written) <= 1) return;
        position = current;
        written = current;
        resumeAt = performance.now() + 700;
        if (current < width || current > width * 7) center();
      }, { passive: true });
      viewport.addEventListener('scrollend', () => {
        if (!touching && userScrolling) {
          userScrolling = false;
          center();
        }
      }, { passive: true });
      viewport.addEventListener('wheel', () => { userScrolling = true; resumeAt = performance.now() + 700; }, { passive: true });
      viewport.addEventListener('focusin', (event) => { focused = event.target.matches(':focus-visible'); });
      viewport.addEventListener('focusout', (event) => { focused = viewport.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); });
      const resume = () => {
        if (document.hidden) return;
        touching = false;
        userScrolling = false;
        focused = viewport.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        position = viewport.scrollLeft;
        written = position;
        previous = 0;
        resumeAt = performance.now() + 150;
      };
      document.addEventListener('visibilitychange', resume);
      window.addEventListener('focus', resume);
      window.addEventListener('pageshow', resume);
      new ResizeObserver(measure).observe(first);
      mobile.addEventListener('change', measure);
      const frame = (now) => {
        if (!viewport.isConnected) return;
        const elapsed = previous ? Math.min(now - previous, 50) : 0;
        previous = now;
        if (mobile.matches && width && !reduced.matches && !document.hidden && !touching && !focused && now >= resumeAt) {
          position += width / 26000 * elapsed;
          if (position > width * 7 || position < width) position = width * 4 + ((position % width) + width) % width;
          write();
        }
        requestAnimationFrame(frame);
      };
      measure();
      requestAnimationFrame(frame);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
